module.exports = __webpack_public_path__ + "static/1_1_defineai_FR-9e84c5c6c667ea9ca32bedc37f45059b.svg";